import { createSlice } from '@reduxjs/toolkit';

// Ephemeral UI flag — not persisted. Lifted out of ChatPage's local state so NotificationBell
// (rendered in TopBar, outside ChatPage's tree) can toggle the panel closed on a second click
// instead of only ever being able to open it via the one-shot ?notifications=open URL param.
interface NotificationsPanelState {
  isOpen: boolean;
}

const notificationsPanelSlice = createSlice({
  name: 'notificationsPanel',
  initialState: { isOpen: false } as NotificationsPanelState,
  reducers: {
    openNotificationsPanel(state) {
      state.isOpen = true;
    },
    closeNotificationsPanel(state) {
      state.isOpen = false;
    },
    toggleNotificationsPanel(state) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const { openNotificationsPanel, closeNotificationsPanel, toggleNotificationsPanel } = notificationsPanelSlice.actions;
export default notificationsPanelSlice.reducer;
